import React from "react";
import styles from "./WidgetPreview.module.scss";

const WidgetPreview = ({
  colorBg,
  colorMain,
  colorText,
  titleWidget,
  nameAssistant,
}) => {
  function hexToRgba(hex, alpha) {
    let r = parseInt(hex?.slice(1, 3), 16);
    let g = parseInt(hex?.slice(3, 5), 16);
    let b = parseInt(hex?.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  const backgroundOutcomeMessage = hexToRgba(colorMain, 0.8);

  const style = document.createElement("style");
  style.innerHTML = `
    #chat-input::placeholder {
      color: ${colorText};
      opacity: 1;
    }`;
  document.head.appendChild(style);
  // useEffect(() => {
  //   const script = document.createElement("script");
  //   script.src = `${process.env.PUBLIC_URL}/widget (1).js?wt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ3aWRnZXRJZCI6ImRlY2Q5NTFhLWZlMzUtNDJiNC1hODk0LTdmZWQ2YTcyNTNlMCJ9.tq4jTwz8RHrfH5s2ZETu4ScPNRA1TH2AoigpNI0ck1k&h=Чат с продажником&an=Владислав Забота&hex=#ffffff&bhex=#000000&thex=#000000"`;
  //   script.async = true;

  //   document.body.appendChild(script);

  //   // Удаление скрипта при размонтировании компонента
  //   return () => {
  //     document.body.removeChild(script);
  //   };
  // }, []);
  return (
    <div className={styles.widgetPreview}>
      <div
        id="chat-box"
        style={{ background: colorBg }}
        className={styles.chatBox}
      >
        <div className={styles.chatHeader} style={{ background: colorMain }}>
          <div className={styles.chatHeaderInfo}>
            <span style={{ color: colorText }}>{titleWidget}</span>
            <span style={{ color: colorText }} className={styles.nameAssistant}>
              {nameAssistant}
            </span>
          </div>
          <div className={styles.chatCloseButton}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="19"
              fill={colorText}
              viewBox="0 0 320 512"
            >
              <path
                fill={colorText}
                d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
              />
            </svg>
          </div>
        </div>
        <div className={styles.chatContentWrapper}>
          <div className={styles.chatContent} id="chat-content">
            <div
              style={{
                background: backgroundOutcomeMessage,
                color: colorText,
              }}
              className={styles.userMessage}
            >
              Привет!
            </div>
            <div
              style={{ background: colorMain, color: colorText }}
              className={styles.botMessage}
            >
              Привет! Чем я могу тебе помочь?
            </div>
          </div>
        </div>
        <div className={styles.chatInputContainer}>
          <input
            style={{
              border: `0.8px solid ${colorText}`,
              background: colorMain,
              color: colorText,
            }}
            id="chat-input"
            placeholder="Введите ваш вопрос ..."
          />
          <div
            className={styles.sendMessageButton}
            style={{
              border: `0.8px solid ${colorText}`,
              background: colorMain,
              color: colorText,
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="18"
              fill={colorText}
              viewBox="0 0 512 512"
            >
              <path
                fill={colorText}
                d="M511.1 255.1c0 12.8-7.625 24.38-19.41 29.41L44.6 477.4c-4.062 1.75-8.344 2.594-12.59 2.594c-8.625 0-17.09-3.5-23.28-10.05c-9.219-9.766-11.34-24.25-5.344-36.27l73.66-147.3l242.1-30.37L77.03 225.6l-73.66-147.3C-2.623 66.3-.4982 51.81 8.72 42.05c9.25-9.766 23.56-12.75 35.87-7.453L492.6 226.6C504.4 231.6 511.1 243.2 511.1 255.1z"
              />
            </svg>
          </div>
        </div>
      </div>
      <div
        className={styles.widget}
        style={{ backgroundColor: colorMain }}
        onMouseEnter={(e) => {
          // Изменяем тень только у div
          e.currentTarget.style.boxShadow = `0px 0px 31px 0px ${colorMain}`;
        }}
        onMouseLeave={(e) => {
          // При уходе курсора сбрасываем тень только у div
          e.currentTarget.style.boxShadow = `0px 4px 4px rgba(34, 60, 80, 0.2)`;
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={33}
          height={26}
          fill={colorText}
          viewBox="0 0 640 512"
        >
          <path
            fill={colorText}
            d="M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8l-.2 .2s0 0 0 0s0 0 0 0C1 327.2-1.4 334.4 .8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.2-11.4C134.1 343.3 169.8 352 208 352zM448 176c0 112.3-99.1 196.9-216.5 207C255.8 457.4 336.4 512 432 512c38.2 0 73.9-8.7 104.7-23.9c7.5 4 16 7.9 25.2 11.4c18.3 6.9 40.3 12.5 62.1 12.5c6.9 0 13.1-4.5 15.2-11.1c2.1-6.6-.2-13.8-5.8-17.9c0 0 0 0 0 0s0 0 0 0l-.2-.2c-.2-.2-.6-.4-1.1-.8c-1-.8-2.5-2-4.3-3.7c-3.6-3.3-8.5-8.1-13.3-14.3c-5.5-7-10.7-15.4-14.2-24.7c24.9-29 39.6-64.7 39.6-103.4c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5z"
          />
        </svg>
      </div>
    </div>
  );
};

export default WidgetPreview;
